import React, { Component } from 'react'
import PropTypes from 'prop-types'

class ButtonHex extends Component {
  render () {
    return (
      <div id={this.props.id} className='buttonHex' onClick={this.props.onClick}><i className='ac ac-hamburger' /></div>
    )
  }
}

ButtonHex.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func
}

export default ButtonHex



// WEBPACK FOOTER //
// ./src/components/ButtonHex.js